export default "__VITE_ASSET__B_Glcu5e__"